import { render, staticRenderFns } from "./DemandeAdmissionPublic.vue?vue&type=template&id=916ff2d8"
import script from "./DemandeAdmissionPublic.vue?vue&type=script&lang=js"
export * from "./DemandeAdmissionPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports